var _defs, _path, _line, _circle, _path2, _line2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew246({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.87,1.49A3.26,3.26,0,1,1,8.87,8"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.87,
    y1: 1.49,
    x2: 4.66,
    y2: 1.49
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.78,
    cy: 1.49,
    r: 0.99
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,14.51A3.26,3.26,0,1,0,9,8"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 8.95,
    y1: 14.51,
    x2: 4.75,
    y2: 14.51
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 4.86,
    cy: 14.51,
    r: 0.99
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew246);
export default __webpack_public_path__ + "static/media/Symbolpack_New_246.8961c311874eede7c5e0e51424a4c5c5.svg";
export { ForwardRef as ReactComponent };